import { resetRouter, dynamicRoutes } from "@/router";

import Layout from "@/layout";
import config from "@/static/config";
import vm from "../../main";
const getDefaultState = () => {
  return {
    manager_token: "",
    name: "",
    avatar: "",
    companyId: "",
    trunkId: "",
    trunkType: "",
    loginType: "",
    leftMenuList: [],
    menuTabs: [],
    activeMenuTab: "1",
    userId: "",
    account: "",
  };
};

const state = getDefaultState();

const mutations = {
  SET_USER_ID(state, data) {
    state.userId = data;
  },
  SET_ACCOUNT: (state, data) => {
    state.account = data;
  },
  SET_ACTIVE_MENU_TAB(state, data) {
    state.activeMenuTab = data;
  },
  SET_MENU_TABS(state, data) {
    state.menuTabs = data;
  },
  SET_LEFT_MENU_LIST(state, data) {
    state.leftMenuList = data;
  },
  SET_LOGIN_TYPE(state, data) {
    state.loginType = data;
  },
  RESET_STATE: (state) => {
    Object.assign(state, getDefaultState());
  },
  SET_TOKEN: (state, token) => {
    state.manager_token = token;
  },
  SET_NAME: (state, name) => {
    state.name = name;
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar;
  },
  SET_COMPANYID: (state, companyId) => {
    state.companyId = companyId;
  },
  SET_TRUKID: (state, trunkId) => {
    state.trunkId = trunkId;
  },
  SET_TRUKTYPE: (state, trunkType) => {
    state.trunkType = trunkType;
  },
};

const actions = {
  // user avatar
  avatar({ commit }, avatar) {
    commit("SET_AVATAR", avatar);
  },
  // user login
  login({ dispatch, commit }, data) {
    console.log(data);
    return new Promise((resolve, reject) => {
      vm.$api.user
        .login(data)
        .then((res) => {
          console.log("正常");
          console.log(res);
          if (res.data && res.data.code && res.data.code + "" === "49999") {
            vm.$confirm("此账号已经在其他地方登陆了，是否继续登录?", "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
              callback: (action) => {
                if (action === "confirm") {
                  var obj = { ...data };
                  obj.forcedLogin = 1;

                  vm.$api.user.login(obj).then((res) => {
                    commit("SET_TOKEN", JSON.parse(res).token);
                    dispatch("getUserPermission");
                    resolve();
                  })
                    .catch((e) => {
                      reject("lll");
                    });
                } else {
                  reject("lll");
                }
              },
            });
          } else {
            commit("SET_TOKEN", JSON.parse(res).token);
            dispatch("getUserPermission");
            resolve();
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  // get user info
  getInfo({ commit, state }) {
    console.log("getinfo");

    return new Promise((resolve, reject) => {
      vm.$api.user
        .userInfo()
        .then((response) => {
          commit("SET_USER_ID", response.userId);
          commit("SET_ACCOUNT", response.account);
          commit("SET_AVATAR", response.imagePath);
          commit("SET_NAME", response.realName);
          commit("SET_COMPANYID", response.trunkInfo.companyId);
          commit("SET_TRUKID", response.trunkInfo.trunkId);
          commit("SET_TRUKTYPE", response.trunkInfo.trunkType);
          commit("app/MODEL_LOGIN", false, { root: true });
          if (state.leftMenuList.length > 0) {
            vm.$router.push(state.leftMenuList[0].path);
          } else {
            // 2026-10-25 修复（与 factory 同款）：权限树为空（无本系统权限）时不再
            // push('/home') 被守卫"暂无权限"弹回，提示一次并留在登录页。
            let permEmpty = true;
            try {
              permEmpty =
                Object.keys(
                  JSON.parse(localStorage.getItem("permission_list") || "{}")
                ).length === 0;
            } catch (e) {
              permEmpty = true;
            }
            if (permEmpty) {
              vm.$message &&
                vm.$message.warning("当前账号无访问权限，请联系管理员开通");
            } else {
              vm.$router.push("/home");
            }
          }

          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  // 获取用户权限
  getUserPermission({ dispatch, commit, state }, path) {
    console.log("getUserPermission------------------------------------------");
    return new Promise((resolve, reject) => {
      vm.$api.user
        .accountPermission()
        .then((res) => {
          console.log(res);
          let permissionListMap = {};
          res.forEach((item) => {
            permissionListMap[item.applicationCode] = item.resourceMenuList;
          });
          localStorage.setItem(
            "permission_list",
            JSON.stringify(permissionListMap)
          );
          localStorage.setItem("permission_list_maomao", JSON.stringify(res));
          // localStorage.setItem(
          // 	'permission_list_timestamp',
          // 	new Date().getTime()
          // )
          dispatch("getInfo");
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  // 清空用户权限
  clearUserPermission({ commit }) {
    commit("SET_LEFT_MENU_LIST", []);
  },
  // user logout
  logout({ commit, state }, Vue) {
    return new Promise((resolve, reject) => {
      Vue.$api.user
        .logout()
        .then(() => {
          resetRouter();
          commit("SET_AVATAR", "");
          commit("SET_NAME", "");
          commit("SET_COMPANYID", "");
          commit("SET_TRUKID", "");
          commit("SET_TRUKTYPE", "");
          commit("RESET_STATE");
          commit("SET_TOKEN", "");
          commit("app/SET_INIT_PERMISSION", false, { root: true });
          //Vue.$router.push(`/login`);
          window.location.href = config.baseUrlMao + "/#/login";
          location.reload();
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  // remove token
  resetToken({ commit }) {
    return new Promise((resolve) => {
      removeToken(); // must remove  token  first
      commit("RESET_STATE");
      resolve();
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
